export { VehicleDataSpotlight } from './VehicleDataSpotlight'
export { VehicleDataSpotlightGroup as default } from './VehicleDataSpotlightGroup'

export type { VehicleDataSpotlightProps } from './VehicleDataSpotlight'
export type { VehicleDataSpotlightGroupProps } from './VehicleDataSpotlightGroup'